<template>
  <div>
    <!-- 头部模板 -->
    <header-yjj-m></header-yjj-m>
    <div class="slide-img" ref="slide">
      <img id="slideImg" src="../../../assets/slide-1.jpg" ref="slideImg">
    </div>

    <div class="container" style="min-height: 580px;">
      <van-tabs v-model="active" @click="onClick">
        <van-tab v-for="item in navList" :title="item.name" :key="item.index" >
          <div style="margin-top: 20px;">
            <div class="item" v-for="item in displayList" :key="item.index" style="margin-bottom: 20px;" @click="bigImg(item.imgsrc)">
              <img :src="item.imgsrc" style="width: 100%">
              <p style="color: black">{{ item.title }}</p>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>

<!--    <div :class="{isShow:isShowFlag}" style="width: 100%;height: 100%;overflow: hidden;position:fixed;top:0;left:0;background: rgba(0,0,0,1);z-index: 1000;">-->
<!--      <img :src="bigImgSrc" style="width: 100%;">-->
<!--    </div>-->

    <van-overlay :show="show" class="bigimg">
      <h1 style="position: absolute;top:30px;right: 30px;color:white;" @click="closeBigImg()">
        <van-icon name="cross" />
      </h1>
      <div >
        <img :src="bigImgSrc" style="width: 100%;">
      </div>

    </van-overlay>

    <!-- 底部模板 -->
    <footer-yjj-m></footer-yjj-m>
  </div>
</template>

<script>
import HeaderYjjM from "@/components/yjj/mobile/HeaderYjjM";
import FooterYjjM from "@/components/yjj/mobile/FooterYjjM";
import {request} from "@/request/request";

export default {
  name: "DisplayListYjjM",
  components: {
    HeaderYjjM,
    FooterYjjM
  },
  data(){
    return{
      active: 0,
      activeFlag:'tongzhi',
      restfulUrl:'displays',
      columnName:1,
      navList:[
        {name:'民族烽火',columnId:'tongzhi',},
        {name:'奋起抵抗',columnId:'dongtai',},
        {name:'浴血奋战',columnId:'dongtai',},
        {name:'不屈不挠',columnId:'dongtai',},
        {name:'时代强音',columnId:'dongtai',},
        {name:'英灵永驻',columnId:'dongtai',},
      ],
      displayList:[],
      bigImgSrc:'',
      isShowFlag:true,
      show:false,
    }
  },
  methods:{
    onClick(name) {

      this.getListByColumn(name + 1);
    },
    navCur(data){
      console.log(data)
    },
    getListByColumn(column){
      request({
        method:'POST',
        url:this.restfulUrl+'/getcolumn',
        data:{columnId:column}
      }).then(res =>{
        this.displayList = res.data;
      },err=>{
        console.log(err)
      })
    },
    bigImg(data){
      this.bigImgSrc = data;
      this.show = true;
    },
    closeBigImg(){
      this.show = false
    }
  },
  mounted() {
    this.getListByColumn(1);
  },
  metaInfo() {
    return {
      title: this.$route.meta.title || 'My Vue App'
    };
  }

}
</script>

<style scoped>
.container{
  padding:0 10px;
}
.slide-img{
  width:100%;
  overflow: hidden;
}
.slide-img img{
  width: 100%;
}

.isShow{
  display:none
}

.bigimg{
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
